var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { styled } from '@mui/material';
import React, { createRef, useEffect } from 'react';
import StepInput from './StepInput';
var SStepInput = styled(StepInput)({ marginLeft: '12px' });
var Ampm = function (_a) {
    var value = _a.value, onChange = _a.onChange, props = __rest(_a, ["value", "onChange"]);
    var ref = createRef();
    useEffect(function () {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('wheel', function (event) {
            event.preventDefault();
        }, {
            passive: false,
        });
    }, []);
    var handleChange = function () {
        onChange(value === 'AM' ? 'PM' : 'AM');
    };
    var handleKeyDown = function (event) {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();
            event.stopPropagation();
            handleChange();
        }
    };
    return (React.createElement(SStepInput, __assign({}, { value: value, ref: ref }, { onStepUp: handleChange, onStepDown: handleChange, onKeyDown: handleKeyDown, onWheel: handleChange }, props)));
};
export default Ampm;
